import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import api from "./api";
import {
  empresaActual, fijarEmpresa, guardarLista, listaEmpresas, olvidarEmpresa,
} from "./empresa";
import EscogerEmpresa from "./components/EscogerEmpresa";
import { Box, CircularProgress, Typography } from "@mui/material";

export default function PrivateRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [escoger, setEscoger] = useState(null);   // DA-16: varias empresas y ninguna escogida
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      // DA-16: primero, a qué empresas puede entrar (con la sesión de Google
      // o con la cookie del hub). Con una, esa; con varias, la ya escogida
      // en este navegador o que escoja.
      let lista = listaEmpresas();
      if (!lista) {
        try {
          lista = (await api.get("/auth/empresas")).data;
          guardarLista(lista);
        } catch {
          setIsAuthenticated(false);
          setLoading(false);
          return;
        }
      }
      const actual = empresaActual();
      if (lista.length === 1) {
        if (actual !== lista[0].identificador) fijarEmpresa(lista[0].identificador);
      } else if (lista.length > 1 && !lista.some((e) => e.identificador === actual)) {
        olvidarEmpresa();
        setEscoger(lista);
        setLoading(false);
        return;
      }
      if (firebaseUser && localStorage.getItem("user_id")
          && localStorage.getItem("user_empresa") === empresaActual()) {
        setIsAuthenticated(true);
        setLoading(false);
        return;
      }
      // Sin sesión de Google en este navegador puede haber la del hub de
      // aplicaciones (DA-9): la cookie de apps.nara.chat llega sola al
      // backend, que la reconoce. Si responde, se entra sin pedir nada.
      try {
        const { data } = await api.get("/auth/me");
        localStorage.setItem("user_id", data.user_id);
        localStorage.setItem("user_email", data.email);
        localStorage.setItem("user_nombre", data.nombre);
        localStorage.setItem("user_rol", data.rol);
        localStorage.setItem("user_empresa", empresaActual() || "");
        setIsAuthenticated(true);
      } catch {
        setIsAuthenticated(false);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <Box sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#0f172a",
      }}>
        <CircularProgress sx={{ color: "#6366f1", mb: 2 }} />
        <Typography sx={{ color: "rgba(255, 255, 255, 0.7)" }}>
          Verificando sesion...
        </Typography>
      </Box>
    );
  }

  if (escoger) return <EscogerEmpresa empresas={escoger} />;

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
